import React, {useState} from 'react';

const useHover = () => {
    const [state, setState] = useState(false)

    const handleMouseOver = () => {
        setState(true)
    }

    const handleMouseOut = () => {
        setState(false)
    }
    return [state, handleMouseOver, handleMouseOut]
};

export default useHover;